/* unplugin-vue-components disabled */import { render } from "./track-companies.vue?vue&type=template&id=63d6f8b8&scoped=true"
import script from "./track-companies.vue?vue&type=script&lang=js"
export * from "./track-companies.vue?vue&type=script&lang=js"

import "./track-companies.vue?vue&type=style&index=0&id=63d6f8b8&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d6f8b8"],['__file',"src/pages/pulse/tracker/track-companies.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63d6f8b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63d6f8b8', __exports__)) {
    api.reload('63d6f8b8', __exports__)
  }
  
  module.hot.accept("./track-companies.vue?vue&type=template&id=63d6f8b8&scoped=true", () => {
    api.rerender('63d6f8b8', render)
  })

}


export default __exports__